import React, { useEffect, useState, useCallback } from "react";
import { Trash2, ImageOff } from "lucide-react";
import api, { API, apiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PageHeader, EmptyState, Loader } from "@/components/dashboard/ui";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const CATS = ["Tous", "Hero", "Services", "Équipe", "Arrière-plans", "Logos", "Contact", "Autre"];

export default function AdminMedia() {
  const [items, setItems] = useState(null);
  const [cat, setCat] = useState("Tous");
  const [uploading, setUploading] = useState(false);
  const [upCat, setUpCat] = useState("Autre");

  const load = useCallback(() => {
    const q = cat === "Tous" ? "" : `?category=${encodeURIComponent(cat)}`;
    api.get(`/media${q}`).then(({ data }) => setItems(data || []));
  }, [cat]);
  useEffect(() => { load(); }, [load]);

  const upload = async (e) => {
    const files = Array.from(e.target.files || []); if (!files.length) return;
    setUploading(true);
    try {
      for (const file of files) {
        const fd = new FormData(); fd.append("file", file); fd.append("category", upCat);
        await api.post("/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      }
      toast.success("Image(s) téléversée(s)"); load();
    } catch (er) { toast.error(apiError(er.response?.data?.detail)); }
    finally { setUploading(false); }
  };
  const del = async (m) => { if (!window.confirm("Supprimer cette image ? Vérifiez qu'elle n'est plus utilisée sur le site.")) return; await api.delete(`/media/${m.media_id}`); load(); };
  const saveMeta = async (m, field, val) => { await api.put(`/media/${m.media_id}`, { [field]: val }); };

  if (items === null) return <Loader />;
  return (
    <div>
      <PageHeader title="Bibliothèque de médias" subtitle="Téléversez, organisez et réutilisez toutes les images du site."
        action={
          <div className="flex items-center gap-2">
            <Select value={upCat} onValueChange={setUpCat}><SelectTrigger className="w-36"><SelectValue /></SelectTrigger><SelectContent>{CATS.filter((c) => c !== "Tous").map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select>
            <label className="inline-flex items-center px-4 py-2 rounded-lg bg-primary text-white text-sm cursor-pointer whitespace-nowrap" data-testid="media-upload-btn">
              {uploading ? "Téléversement..." : "Téléverser"}<input type="file" accept="image/*" multiple className="hidden" onChange={upload} />
            </label>
          </div>
        } />
      <div className="mb-4 flex flex-wrap gap-2">
        {CATS.map((c) => <button key={c} onClick={() => setCat(c)} className={`px-3 py-1.5 rounded-full text-sm border ${cat === c ? "bg-primary text-white border-primary" : "border-slate-200 text-slate-600 hover:bg-slate-50"}`}>{c}</button>)}
      </div>
      {items.length === 0 ? <EmptyState icon={ImageOff} title="Aucune image" text="Téléversez votre première image." /> : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {items.map((m) => (
            <div key={m.media_id} className="bg-white rounded-xl border border-slate-200 overflow-hidden" data-testid={`media-card-${m.media_id}`}>
              <div className="aspect-video bg-slate-50"><img src={`${API}/media/file/${m.media_id}`} alt={m.alt} className="w-full h-full object-cover" onError={(e) => { e.currentTarget.style.display = "none"; }} /></div>
              <div className="p-3 space-y-2">
                <p className="text-xs text-slate-400 truncate">{m.filename}</p>
                <Input defaultValue={m.alt} onBlur={(e) => saveMeta(m, "alt", e.target.value)} placeholder="Texte alternatif (ALT)" className="h-8 text-xs" />
                <div className="flex items-center justify-between">
                  <Select defaultValue={m.category} onValueChange={(v) => saveMeta(m, "category", v)}><SelectTrigger className="h-8 text-xs w-28"><SelectValue /></SelectTrigger><SelectContent>{CATS.filter((c) => c !== "Tous").map((c) => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent></Select>
                  <button onClick={() => del(m)}><Trash2 className="h-4 w-4 text-rose-400 hover:text-rose-600" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
